angular.module('unergie.main')
.directive('userInfoContractPaymentDetails', ($rootScope, $filter, NgTableParams, ApiCons, DataAccess, BoFeaturesService,
    Rules, PaymentService, MetaWatcher, DataAccessSearch, ContractService, ReferencesService, TimetableGeneration,
    ApiUser, ModalService, AlertManager, ErrorCatcher, FilterMapping, DataAccessInvoices, AdminComments) =>
    ({
        restrict: 'E',
        templateUrl: '/states/userContractInfo/component/contract/userInfoContractPaymentDetails.html',
        link($scope) {
            const feats = BoFeaturesService.getModuleFeatures('contracts')

            $scope.hideNotModifyingBalance = false
            $scope.paymentFilter = {}

            $scope.canChangePaymentsStatus = BoFeaturesService.isFeatureOn('canChangePaymentsStatus')
            $scope.canCbRefund = BoFeaturesService.isFeatureOn('canCbRefund')
            $scope.showTools = !BoFeaturesService.get('isEnvProd')
            $scope.providerLabel = BoFeaturesService.get('providerLabel')
            $scope.trigger_mapping = FilterMapping.trigger

            $scope.canRegenTimetable = feats.canRegenTimetable
            $scope.viewAdminPaymentList = feats.viewAdminPaymentList
            $scope.displayViewCSR = !feats.viewAdminPaymentList

            $scope.canStaggerPayment = feats.canStaggerPayment
            $scope.canCancelPayment = (payment) => {
                return feats.canCancelPayment && payment.status === 0
            }

            $scope.synching = {}
            $scope.loggingPayment = {}

            $scope.changePaymentFilter = () => {
                if ($scope.hideNotModifyingBalance) {
                    $scope.paymentFilter = { modifyingBalance: true }
                } else {
                    $scope.paymentFilter = {}
                }
            }

            ReferencesService.getRef('sepa-error-codes', true).then((mapping) => {
                $scope.sepaErrorsMapping = _.keyBy(mapping, 'id')
            })

            // NG-TABLE COLUMNS
            $scope.resetCSRShow = () => {
                $scope.show = {
                    id: false,
                    status: true,
                    raw_status: false,
                    amount: true,
                    value_date: false,
                    payment_date: true,
                    modification_ts: false,
                    type: true,
                    raw_type: false,
                    mode: true,
                    label: true,
                    trigger: true,
                    actions: true,
                    expand: true,
                }
            }

            $scope.resetCSRShow()

            $scope.cols = {
                id: { label: 'ID (Admin)', isVisible: false },
                status: { label: 'Status', isVisible: true },
                raw_status: { label: 'Statut Technique (Admin)', isVisible: false },
                amount: { label: 'Montant', isVisible: true },
                value_date: { label: 'Date de valeur', isVisible: true },
                payment_date: { label: 'Date de paiement', isVisible: true },
                modification_ts: { label: 'Date de modification (Admin)', isVisible: false },
                type: { label: 'Type', isVisible: true },
                raw_type: { label: 'Code (Admin)', isVisible: false },
                mode: { label: 'Moyen de paiement', isVisible: true },
                label: { label: 'Libellé du paiement', isVisible: true },
                trigger: { label: 'Initiative', isVisible: true },
                actions: { label: 'Actions (Admin)', isVisible: false },
                expand: { label: 'Details', isVisible: true },
            }

            // PAYMENT TESTS
            $scope.paymentIsAdvanceCons = (payment) => payment.status === 98

            $scope.paymentNotOk = (payment) => (payment.status >= 90) && (payment.status < 98)

            $scope.paymentNotYetValidated = (payment) => PaymentService.paymentNotYetValidated(payment)

            $scope.paymentValidated = (payment) => !PaymentService.paymentNotYetValidated(payment)

            $scope.isPaymentCancellable = (payment) => payment && (![0, 11, 70].includes(payment.status))

            $scope.isPaymentOkable = (payment) => payment && (![10, 11, 55].includes(payment.status))

            $scope.isPaymentKoable = (payment) => payment && (![10, 11, 95].includes(payment.status))

            $scope.modifyingBalance = (payment, lastInvoiceDate) => PaymentService.isPaymentModifyingBalance(payment, lastInvoiceDate)

            // PAYMENT LABEL
            $scope.getSimplePaymentStatus = PaymentService.getSimplePaymentStatus

            // HACK ON REG PAYMENT TYPE TO DISTINCT INVOICE REGUL (REG) OR CLIENT REGUL (REC)
            $scope.updateRegRecPaymentType = function (paymentType, paymentLabel) {
                if ((paymentType === 'REG') && _.isString(paymentLabel) && !paymentLabel.toLowerCase().includes('facture')) {
                    return 'REC'
                }
                return paymentType
            }

            // PAYMENT CSR/ADMIN VIEW


            // PAYMENT INIT
            const loadNgTablePaymentsView = function () {
                let filteredPaymentsData = $scope.rawPaymentsData
                if ($scope.displayViewCSR) {
                    // REMOVE ADJ PAYMENT FOR CSR USER
                    filteredPaymentsData = _.filter($scope.rawPaymentsData, (p) => !['ADJ', 'CIR', 'PERTE'].includes(p.type))
                }
                _.each(filteredPaymentsData, (p) => {
                    const refunds = _.filter(p.refunds, (refund) => refund.status <= 55)
                    p.refunded = _.sum(_.map(refunds, 'amount'))
                    p.refundIds = _.map(refunds, 'id')
                    p.modifyingBalance = $scope.modifyingBalance(p, $scope.lastInvoiceDate)
                })
                $scope.contract.filteredPayments = filteredPaymentsData

                $scope.tableParamsPayments = new NgTableParams({ sorting: { payment_date: 'desc' } }, { dataset: filteredPaymentsData })
            }

            $scope.switchCSRAdminView = function () {
                $scope.displayViewCSR = !$scope.displayViewCSR
                loadNgTablePaymentsView()
                if ($scope.displayViewCSR === true) {
                    return $scope.resetCSRShow()
                }
            }

            const loadPayments = function () {
                return DataAccessInvoices.lastInvoice({ id_contract: $scope.contract.id }).$promise
                .then((invoices) => {
                    $scope.lastInvoiceDate = invoices && invoices.length && invoices[0].period_end_date
                    return DataAccessSearch({ orderBy: '-value_date,-creation_ts' })
                    .search({ resource: 'payments', id_contract: $scope.contract.id, withRelated: 'refunds' }).$promise.then((data) => {
                        $scope.rawPaymentsData = data
                        loadNgTablePaymentsView()
                    }).catch(ErrorCatcher)
                })
            }

            const loadBalance = () =>
                DataAccess.contractBalance({ id_contract: $scope.contract.id }).$promise.then((result) => {
                    $scope.balance = result.balance
                    $scope.planned = result.planned
                }).catch(ErrorCatcher)


            const loadAll = function () {
                loadPayments()
                loadBalance()
            }

            ReferencesService.getRef('paymentStatuses').then((mapping) => {
                $scope.paymentMapping = mapping
            })

            // LOG PAYMENTS
            $scope.logPaymentFields = PaymentService.logPaymentFields(BoFeaturesService.isFeatureOn('traceExtraPayment'))
            $scope.logPaymentPayload = PaymentService.logPaymentPayload($scope.contract)

            $scope.prepareLogPaymentPayload = () => PaymentService.prepareLogPaymentPayload($scope.logPaymentPayload)

            $scope.logPayment = () => PaymentService.logPayment($scope.logPaymentPayload, $scope.loggingPayment)
            .then(() => MetaWatcher.notif('PAYMENT_CHANGED', $scope.contract))

            // SYNC SLIMPAY
            $scope.syncFields = PaymentService.syncFields()
            $scope.syncPayload = PaymentService.syncPayload($scope.account.customer_id)

            $scope.syncSlimpay = () => PaymentService.syncSlimpay($scope.syncPayload, $scope.synching)

            // VALIDATE PAYMENT
            $scope.validating = {}

            $scope.validatePayment = (payment) => PaymentService.validatePayment(payment, $scope.validating)
            .then(() => MetaWatcher.notif('PAYMENT_CHANGED', $scope.contract))

            // ACTIONS ON PAYMENTS
            $scope.okPayment = function (payment) {
                payment.oking = true
                return DataAccess.modifyPayment({ id_payment: payment.id }, { status: 55 }).$promise.then(() => {
                    AlertManager.success('Paiement Oké !')
                    return MetaWatcher.notif('PAYMENT_CHANGED', $scope.contract) }).catch(ErrorCatcher)
                .finally(() => {
                    payment.oking = false
                })
            }

            $scope.cancelPayment = function (payment) {
                payment.cancelling = true
                return DataAccess.modifyPayment({ id_payment: payment.id }, { status: 70 }).$promise.then(() => {
                    AlertManager.success('Paiement annulé !')
                    AdminComments.addComment({ object: $scope.contract.id, comment: `Paiement de ${payment.amount} annulé !` }).$promise.catch(ErrorCatcher)
                    return MetaWatcher.notif('PAYMENT_CHANGED', $scope.contract) }).catch(ErrorCatcher)
                .finally(() => {
                    payment.cancelling = false
                })
            }


            $scope.prepareKoPayment = () => {
                $scope.koPaymentField = {
                    rejection_code: {
                        type: 'select',
                        label: 'Type de rejet',
                        enum: _.map($scope.sepaErrorsMapping, (val) => ({ value: val.id, label: `${val.id} ${val.label}` })),
                    },
                }
            }


            $scope.koPayment = function (payment) {
                payment.koing = true
                return DataAccess.modifyPayment({ id_payment: payment.id }, { status: 95, rejection_code: payment.rejection_code }).$promise.then(() => {
                    AlertManager.success('Paiement Kaho !')
                    return MetaWatcher.notif('PAYMENT_CHANGED', $scope.contract) }).catch(ErrorCatcher)
                .finally(() => {
                    payment.koing = false
                })
            }

            $scope.cancelPaymentInitial = function (payment) {
                payment.cancellingPaymentInitial = true
                return DataAccess.cancelInitialPayment({ id_payment: payment.id }, {}).$promise.then(() => {
                    AlertManager.success('Paiement annulé !')
                    return MetaWatcher.notif('PAYMENT_CHANGED', $scope.contract) }).catch(ErrorCatcher)
                .finally(() => {
                    payment.cancellingPaymentInitial = false
                })
            }

            $scope.openStaggerPaymentModal = (payment) =>
                ModalService.openModal({ type: 'staggerPaymentModal', size: 'md' },
                    { payment, contract: $scope.contract },
                    (result) => MetaWatcher.notif('PAYMENT_CHANGED', $scope.contract))


            $scope.canFetch = (payment) => (payment.status > 0 && payment.status < 98 && ['CB', 'SEPA'].includes(payment.mode))

            $scope.fetchingBankStatus = PaymentService.fetchSlimpayStatus

            $scope.refundCbPayment = (payment) => PaymentService.refundCbPayment(payment, $scope.refundTemplate)
            .then(() => MetaWatcher.notif('PAYMENT_CHANGED', $scope.contract))
            $scope.canRefund = (payment) => PaymentService.canRefund(payment) && $scope.balance > 0
            $scope.refundFields = PaymentService.refundFields
            $scope.generateRefundTemplate = (payment) => {
                $scope.refundTemplate = PaymentService.generateRefundTemplate(payment, $scope.balance)
            }

            $scope.changeStatusPayload = {
                status: '',
                rejection_date: moment(),
                rejection_lbl: '',
            }

            $scope.changeStatusFieldsTemplate = {
                status: {
                    label: 'Status',
                    required: true,
                    type: 'select',
                    enum: [],
                },
                rejection_date: {
                    label: 'Date de refus',
                    required: true,
                    type: 'datetime',
                },
                rejection_lbl: {
                    label: 'Commentaire rejet',
                    type: 'text',
                },
            }

            $scope.isModifiable = (payment) => {
                return payment.status === 11 ||
                ([50, 55].includes(payment.status) && ['TRANSFER', 'CHECK', 'ENERGY_CHECK', 'EXTRA'].includes(payment.mode) && !['CIR', 'PERTE'].includes(payment.type)) ||
                (payment.status === 90 && ['SEPA'].includes(payment.mode))
            }

            $scope.prepareChgStatusPayload = (payment) => {
                payment.closeChange = false
                _.each(_.filter($scope.tableParamsPayments.data, (p) => p.id !== payment.id && !p.closeChange), (p) => {
                    p.closeChange = true
                })
                $scope.changeStatusFields = _.clone($scope.changeStatusFieldsTemplate)
                if (payment.status === 11) {
                    $scope.changeStatusFields.status.enum = [{ label: 'En erreur', value: 90 }]
                    delete $scope.changeStatusFields.rejection_date
                    delete $scope.changeStatusPayload.rejection_date
                } else if (payment.status === 90) {
                    $scope.changeStatusFields.status.enum = [{ label: 'Initial', value: 0 }]
                    delete $scope.changeStatusFields.rejection_date
                    delete $scope.changeStatusPayload.rejection_date
                    delete $scope.changeStatusPayload.rejection_lbl
                } else if (['TRANSFER', 'CHECK', 'ENERGY_CHECK', 'EXTRA'].includes(payment.mode)) {
                    $scope.changeStatusFields.status.enum = [{ label: 'Refusé', value: 95 }]
                    $scope.changeStatusPayload.rejection_date = moment()
                }
                $scope.changeStatusPayload.status = $scope.changeStatusFields.status.enum[0].value
            }

            $scope.updatePaymentStatus = (payment) => {
                payment.modifying = true
                const payload = _.clone($scope.changeStatusPayload)
                payload.rejection_date = payload.rejection_date && moment(payload.rejection_date).toISOString()
                return DataAccess.modifyPaymentStatus({ id_payment: payment.id }, payload).$promise.then(() => {
                    AlertManager.success('Statut modifié !')
                    MetaWatcher.notif('PAYMENT_CHANGED', $scope.contract)
                })
                .catch(ErrorCatcher)
                .finally(() => {
                    payment.modifying = false
                })
            }

            MetaWatcher.watch('PAYMENT_CHANGED', 'paymentsDirective', $scope, loadAll)
            loadAll()
        },
    })
)
